"use client";

import { LoadScript } from "@react-google-maps/api";
import { PropsWithChildren } from "react";

const libraries = ["places"];

const GoogleMapsProvider = ({ children }: PropsWithChildren) => {
  return (
    <LoadScript
      googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!}
      libraries={libraries as any}
    >
      {children}
    </LoadScript>
  );
};

export default GoogleMapsProvider;
